"use strict";

var _interopRequireWildcard = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.regexp.test.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.json.stringify.js");

require("core-js/modules/es.number.to-fixed.js");

require("core-js/modules/es.string.replace.js");

require("regenerator-runtime/runtime.js");

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _Title = _interopRequireDefault(require("./components/Title"));

var _NoData = _interopRequireDefault(require("@/components/common/NoData"));

var _SettingAccount = _interopRequireDefault(require("./components/SettingAccount"));

var Account = _interopRequireWildcard(require("@/model/user/account"));

var _index = require("@/model/assets/index");

var _commonMixin = _interopRequireDefault(require("@/components/common/commonMixin.vue"));

var _assets = require("@/model/ucenter/assets");

var _message = require("@/components/dialog/message.js");

var _getTime = require("@/assets/js/getTime");

var _accuracy = require("@/assets/js/accuracy");

var _index2 = require("@/model/exchange/index");

var _vuex = require("vuex");

var _routeSplicing = _interopRequireDefault(require("@/assets/js/routeSplicing"));

var _globalFun = _interopRequireDefault(require("@/assets/js/globalFun.js"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { getUserInfo } from "model/ucenter/ucenter";
var refreshTime = 5000;
var _default = {
  mixins: [_commonMixin.default],
  data: function data() {
    var _this = this;

    return {
      userInfo: {},
      avatar: "",
      nick_name: "",
      authLevelTotal: 2,
      //设置总安全级别
      authLevelText: {
        1: "低",
        2: "中",
        3: "高"
      },
      exchangeLimit: {},
      // 提币限额
      pageInfo: {
        pageCount: 0,
        pageTotal: 0,
        pageSize: 10,
        pageCurrent: 1
      },
      assetsList: {},
      tableData: [],
      assetsShow: "",
      assetsShowCurrency: {},
      assetsListTimer: null,
      historyLoading: false,
      settingAccountData: {
        getMobileType: 46,
        getMailType: 45,
        isShowDialog: false,
        updateShowDialog: function updateShowDialog(val) {
          _this.settingAccountData.isShowDialog = val;
        },
        getUserInfoInit: this.getUserInfoInit
      },
      username: "",
      voucherInterval: null,
      marginMap: {
        u_valuation: "--",
        all_u_valuation: {
          usd: "--"
        }
      },
      contractMap: {
        u_valuation: "--",
        all_u_valuation: {
          usd: "--"
        }
      },
      stockMap: {
        u_valuation: "--",
        all_u_valuation: {
          usd: "--"
        }
      },
      financeMap: {
        u_valuation: "--",
        all_u_valuation: {
          usd: "--"
        }
      },
      remainMap: {
        u_valuation: "--",
        all_u_valuation: {
          usd: "--"
        }
      },
      globalFun: _globalFun.default
    };
  },
  created: function created() {
    var _this2 = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.getUserInfoInit();

            case 2:
              _this2.getAssetsList();

              _context.next = 5;
              return _this2.userLoginLogList({
                page: 1
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  destroyed: function destroyed() {
    clearInterval(this.voucherInterval);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.voucherInterval);
    clearInterval(this.assetsListTimer);
  },
  mounted: function mounted() {
    this.loopRefreshAssets();
  },
  methods: {
    routeSplicing: _routeSplicing.default,
    hideSensitiveInfo: function hideSensitiveInfo(value) {
      if (/^[0-9]{11}$/.test(value)) {
        return (value + "").substr(0, 2) + "****" + (value + "").substr(-2);
      }

      if (typeof value == "string") {
        if (value.indexOf("@") > -1) {
          var sensitiveArr = value.split("@");
          return sensitiveArr[0].substr(0, 2) + "****" + value.substr(-2) + "@" + sensitiveArr[1];
        }
      }

      return value;
    },
    onConfirm: function onConfirm() {
      this.getUserInfoInit();
    },
    onFinance: function onFinance() {
      this.$router.push(this.routeSplicing(this.language, "ucenter/finanManagement"));
    },
    onAssets: function onAssets() {
      this.$router.push(this.routeSplicing(this.language, "ucenter/assets"));
    },
    getItemList: function getItemList() {
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var req, _yield$getCoinList, status, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                req = {
                  __version: "3.4.3",
                  __channel: "2"
                };
                _context2.next = 3;
                return (0, _index.getCoinList)(req);

              case 3:
                _yield$getCoinList = _context2.sent;
                status = _yield$getCoinList.status;
                data = _yield$getCoinList.data;

                if (status == 200) {
                  sessionStorage.setItem("itemList", JSON.stringify(data));
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    loopRefreshAssets: function loopRefreshAssets() {
      var _this3 = this;

      this.assetsListTimer = setInterval(function () {
        return _this3.getAssetsList();
      }, refreshTime);
    },
    getStaticLabel: function getStaticLabel(num) {
      return "".concat((num * 1).toFixed(2));
    },
    login_land: function login_land() {
      return "-";
    },
    // 获取资产列表
    getAssetsList: function getAssetsList() {
      var _this4 = this;

      var params = {
        type: "all"
      };
      (0, _index2.apiGetAssets)(params).then(function (_ref) {
        var status = _ref.status,
            data = _ref.data;

        if (status === 200) {
          _this4.assetsShow = data.assets.u_valuation;
          _this4.assetsShowCurrency = data.assets.all_u_valuation;
          _this4.financeMap = data.finance;
          _this4.marginMap = data.margin;
          _this4.stockMap = data.stock;
          _this4.contractMap = data.contract;
          _this4.remainMap = data.remain;
        } else if (status === -188) {
          clearInterval(_this4.assetsListTimer);
        }
      });
    },
    // 获取用户信息
    getUserInfoInit: function getUserInfoInit() {
      var _this5 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this5$userInfo, userInfo, accountInfo, user_id, nick_name, avatar, str, emailReg, _str, _str2;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Account.getUserInfo();

              case 2:
                _this5.userInfo = _context3.sent;
                // this.userInfo = JSON.parse(localStorage.getItem("userData"));
                _this5.settingAccountData.row = {};
                _this5$userInfo = _this5.userInfo, userInfo = _this5$userInfo.userInfo, accountInfo = _this5$userInfo.accountInfo;

                if (userInfo) {
                  _this5.settingAccountData.userInfo = userInfo;
                  user_id = userInfo.user_id, nick_name = userInfo.nick_name, avatar = userInfo.avatar; // this.nick_name = this.hideSensitiveInfo(
                  //   nick_name ? nick_name : `${user_id}`
                  // );

                  _this5.nick_name = nick_name || _this5.userInfo.accountInfo.username || _this5.globalFun.userDecryption(_this5.userInfo.accountInfo.mobile, "mobile") || _this5.globalFun.userDecryption(_this5.userInfo.accountInfo.email, "email") || _this5.translateTitle("\u7528\u6237") + "".concat(user_id);
                  _this5.avatar = avatar ? avatar : "https://";
                }

                if (!accountInfo) {
                  _context3.next = 21;
                  break;
                }

                if (!accountInfo.username) {
                  _context3.next = 13;
                  break;
                }

                str = accountInfo.username || accountInfo.email || accountInfo.mobile;
                _this5.username = str.length > 2 ? str.substr(0, 2) + "****" + str.substr(-2) : str;
                return _context3.abrupt("return");

              case 13:
                if (!accountInfo.email) {
                  _context3.next = 20;
                  break;
                }

                emailReg = /(.{2}).+(@.+)/g;
                _str = accountInfo.email;
                _this5.username = _str.replace(emailReg, "$1****$2");
                return _context3.abrupt("return");

              case 20:
                if (accountInfo.mobile) {
                  _str2 = accountInfo.mobile;
                  _this5.username = _str2.length > 2 ? _str2.substr(0, 3) + "****" + _str2.substr(-4) : _str2;
                }

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getInitData: function getInitData() {},
    // 页面数据变化
    onPageChange: function onPageChange(val) {
      this.userLoginLogList({
        page: val
      });
    },
    // 获取 24h 内的提币限制
    getUserExchangeLimit: function getUserExchangeLimit() {
      var _this6 = this;

      (0, _assets.getUserExchangeLimit)().then(function (_ref2) {
        var status = _ref2.status,
            data = _ref2.data,
            msg = _ref2.msg;

        if (status === 200) {
          _this6.exchangeLimit = data;
        } else {
          (0, _message.showMessage)({
            message: msg ? msg : status
          });
        }
      });
    },
    // 用户登录记录
    userLoginLogList: function userLoginLogList(pamars) {
      var _this7 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                pamars.page_size = _this7.pageInfo.pageSize;
                _this7.historyLoading = true;
                _context4.next = 4;
                return (0, _assets.userLoginLogList)(pamars).then(function (_ref3) {
                  var status = _ref3.status,
                      data = _ref3.data,
                      msg = _ref3.msg;

                  if (status === 200) {
                    _this7.tableData = data.list;
                    _this7.pageInfo = data.pageInfo;
                  } else {
                    (0, _message.showMessage)({
                      message: msg ? msg : status
                    });
                  }
                });

              case 4:
                _this7.historyLoading = false;

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    getTimeRefor: function getTimeRefor(row) {
      return (0, _getTime.reformatting)(+row.login_time * 1000);
    }
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({
    language: "user/language",
    systemCurrency: "user/currency"
  })), {}, {
    coinOutNum: function coinOutNum() {
      if (JSON.stringify(this.exchangeLimit) !== "{}") {
        var coinOutNum = this.exchangeLimit.coinOutNum;
        return (0, _accuracy.accuracy)(coinOutNum, 2);
      } else {
        return "--";
      }
    },
    limitNum: function limitNum() {
      if (JSON.stringify(this.exchangeLimit) !== "{}") {
        var limitNum = this.exchangeLimit.limitNum;
        return (0, _accuracy.accuracy)(limitNum, 2);
      } else {
        return "--";
      }
    },
    hasUser: function hasUser() {
      if (JSON.stringify(this.userInfo) !== "{}") {
        return true;
      }

      return false;
    },
    isLevel1: function isLevel1() {
      return this.userInfo.userInfo && this.userInfo.userInfo.level >= 1 && this.userInfo.userInfo.status === 2 ? true : false;
    },
    checkAuthLevel: function checkAuthLevel() {
      if (this.hasUser) {
        var is_open_mobile = this.userInfo.authInfo.open_mobile;
        var is_open_email = this.userInfo.authInfo.open_email; // let is_open_google = this.userInfo.authInfo.open_google;

        if (this.userInfo.accountInfo.type === 4) {
          //子账号
          is_open_mobile = this.userInfo.parentUserInfo.open_mobile;
          is_open_email = this.userInfo.parentUserInfo.open_email; // is_open_google = this.userInfo.parentUserInfo.open_google;
        }

        var check_num = 0;
        is_open_mobile === 1 && (check_num += 1);
        is_open_email === 1 && (check_num += 1); // is_open_google === 1 && (check_num += 1);

        check_num = check_num / this.authLevelTotal * 3;

        if (check_num <= 1) {
          check_num = 1;
        } else if (check_num > this.authLevelTotal) {
          check_num = 3;
        }

        return parseInt(check_num);
      } else {
        return 0;
      }
    }
  }),
  components: {
    TopTitle: _Title.default,
    EmptyTable: _NoData.default,
    SettingAccount: _SettingAccount.default
  }
};
exports.default = _default;